import { TreeNode } from 'primeng/api';

export const ChatMessageType = {
  USER_RESPONSE: 'user_response',
  AGENT_RESPONSE: 'agent_response',
  SHIMMER: 'shimmer',
  PLAN: 'plan',
  PLAN_OUTLINE: 'plan_outline',
  QUESTION_AND_ANSWERS: 'qna',
  RECOMMENDATION: 'recommendation'
} as const;

export const ChatMessageStatus = {
  COMPLETED: 'completed',
  PENDING: 'pending'
} as const;

export const SESSION_MERGE_STATUS = {
  YET_TO_START: 'yet_to_start',
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
  FAILED: 'failed'
} as const;

export const SESSION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
} as const;

export const SESSION_MODE = {
  IDEATE: 'ideate',
  BUILD: 'build'
} as const;

export const SESSION_DRIVEN_MODE = {
  AUTO: 'auto',
  MANUAL: 'manual'
} as const;

/** Chat Action Interface */
export interface ChatAction {
  label: string;
  code: string;
  isPrimary?: boolean;
  disabled?: boolean;
  renderAsIcon?: string;
  align?: 'left' | 'right';
}

/** Chat message structure */
export interface ChatMessage {
  id?: string;
  sid?: string;
  type: 'user' | 'assistant';
  text?: string;
  displayedText?: string;
  isStreaming?: boolean;
  plan?: any;
  tableCards?: { tableName: string; fields: { name: string; type: string }[]; expanded?: boolean }[];
  treeTableData?: TreeNode[];
  selectedTreeNodes?: TreeNode[];
  actions?: ChatAction[];
  status?: string;
  showCheckmark?: boolean;
  isCollapsed?: boolean;
  userToggled?: boolean;
  isEditingRoles?: boolean;
  isEditingTables?: boolean;
  isFetching?: boolean;
  createdDate?: Date | string;
  showServerMessageOptions?: boolean;
  showSpeedometer?: boolean;
  elapsedTimeString?: string;
  speedometerTooltip?: string;
  conversationId?: string;
  messageType?: string;
  data?: any[];
  isGrouped?: boolean;
  shimmerGroup?: ChatMessage[];
  label?: string;
  latestShimmerLabel?: string;
  latestShimmerIcon?: string;
  latestShimmerTitle?: string;
  isActionInProgress?: boolean; // Tracks if an action is currently processing (locks all buttons)
  iconActions?: ChatAction[]; // Holds the action objects to be rendered as icon buttons
  leftActions?: ChatAction[]; // Actions aligned to the left
  rightActions?: ChatAction[]; // Actions aligned to the right
  actionTaken?: ChatAction;
  content?: any;
  answers?: Record<string, unknown>;
  preferredAnswers?: Record<string, unknown>;
  questions?: any[];
  config?: any;
  hasAutoOpened?: boolean;
}

export interface DatamodelFieldStructure {
  name: string;
  type: string;
}

export interface DatamodelStructure {
  tableName: string;
  type: string;
  fields: DatamodelFieldStructure[];
}

export interface PlanStructure {
  artifacts?: {
    datamodel?: { create?: DatamodelStructure[]; update?: DatamodelStructure[]; delete?: [] };
    page?: { create?: any[]; update?: any[]; delete?: any[] };
  };
}

export interface SectionItem {
  icon?: string;
  text: string;
}

export interface Section {
  title?: string;
  items: [SectionItem];
}

export interface PlanOutlineStructure {
  sections: Section[];
}
